<div class="modal modal-lg fade show" style="display: block;">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title" *ngIf="isNew">Add menu item</h4>
				<h4 class="modal-title" *ngIf="!isNew">Edit menu item</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="cancel()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                </button>
			</div>
			<div class="modal-body">
                <h5>Menu group: {{this.menuGroup.name}}</h5>


				<div class="mb-3 row">
					<label class="col-sm-4 col-form-label">Menu name</label>
					<div class="col-sm-8">
						<input type="text" class="form-control bordered" [(ngModel)]="menu.name" />
						<span class="form-text m-b-none">
							Enter a short and concise menu name
						</span>
					</div>
				</div>
				<div class="mb-3 row">
					<label class="col-sm-4 col-form-label">Links to external page?</label>
					<div class="col-sm-8">
						<select class="form-control bordered" [(ngModel)]="menu.external">
							<option [ngValue]="1">Yes</option>
							<option [ngValue]="0">No</option>
						</select>
					</div>
				</div>

				<div class="mb-3 row" *ngIf="menu.external === 1">
					<label class="col-sm-4 col-form-label">External Page URL</label>
					<div class="col-sm-8">
						<input type="text" class="form-control bordered" [(ngModel)]="menu.externalURL" />
						<span class="form-text m-b-none">
							Copy and paste the link of the website page you are linking to.
						</span>
					</div>
				</div>

				<div class="mb-3 row" *ngIf="menu.external === 0">
					<label class="col-sm-4 col-form-label">Link to a page</label>
					<div class="col-sm-8">
						<select class="form-control bordered" [(ngModel)]="menu.route">
							<option value="">Select page</option>
							<option [ngValue]="p.route" *ngFor="let p of pages">{{p.name}}</option>
						</select>
					</div>
				</div>
				<div class="mb-3 row">
					<label class="col-sm-4 col-form-label">Menu Name (Signed In)</label>
					<div class="col-sm-8">
						<input type="text" class="form-control bordered" [(ngModel)]="menu.signedInName " />
						<span class="form-text m-b-none">
							Enter a short and concise menu name that will be visible for signed In User
						</span>
					</div>
				</div>
				<div class="mb-3 row">
					<label class="col-sm-4 col-form-label">Route (Signed In)</label>
					<div class="col-sm-8">
						<input type="text" class="form-control bordered" [(ngModel)]="menu.signedInRoute " />
						<span class="form-text m-b-none">
							Copy and paste the link of the website page you are linking to for signed In User
						</span>
					</div>
				</div>

				
<!--				<div class="mb-3 row">-->
<!--					<label class="col-sm-4 col-form-label">How many tile spaces?</label>-->
<!--					<div class="col-sm-8">-->
<!--						<select class="form-control bordered" [(ngModel)]="menu.colspan">-->
<!--							<option *ngFor="let c of cols" value="{{c.Id}}">{{c.name}}</option>-->
<!--						</select>-->
<!--						<span class="form-text m-b-none">-->
<!--							Only required if this menu item is being shown as an image tile-->
<!--						</span>-->
<!--					</div>-->
<!--				</div>-->

				<div class="row">
					<div class="col-4 offset-4 text-center">
						<img *ngIf="!menu.tile" src="/assets/images/no-image.png" class="img-fluid" style="max-height: 150px" />
						<img *ngIf="menu.tile" [src]="menu.tile" class="img-fluid" style="max-height: 150px" />
						<br />
						<button type="button" class="btn btn-primary mt-2" (click)="viewImageLibrary('menuTile')">Select tile image</button>
					</div>
				</div>

			</div>

			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="save()">
					<span *ngIf="isNew">Add menu</span>
					<span *ngIf="!isNew">Save menu</span>
				</button>
			</div>
		</div>
	</div>
</div>

<app-images *ngIf="showImageLibrary" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false" (modalAction)="imageModalAction($event)" (imageSelected)="imageSelected($event)"></app-images>

<div class="modal-backdrop fade show"></div>


